
export const getDeviceInfo = () => {
    return {
        deviceType: navigator.platform,
        appVersion: navigator.appVersion,
        deviceName:  navigator.userAgent,
        deviceId: navigator.userAgent,
    }
}